<template>
  <div class="show_app_auth_btn">
    <a-button type="primary" @click="showAppAuth">查看1688授权</a-button>
    <a-modal v-model:visible="visible" style="top: 70px" width="1200px" :title="getTitle">
      <a-row>
        <a-button type="primary" style="width: 140px" @click="addAuthApp">添加1688授权</a-button>
      </a-row>
      <MyTable :info="tableInfo" @ChangePage="ChangePage">
        <template #appName="{ record }"> {{ record.AppName }} ({{ record.AppTypeVal }}) </template>
        <template #statusStr="{ record }">
          <span :style="{ color: record.IsExpire ? 'red' : '' }">
            {{ !record.IsExpire ? record.StatusStr : record.Msg }}
          </span>
        </template>
        <template #appExpiresIn="{ record, text }">
          <span :style="{ color: record.IsExpire ? 'red' : '' }">
            {{ text }}
          </span>
        </template>
        <template #operate="{ record }">
          <a-space :size="12">
            <a-button
              v-if="record.RelId != branchRelId"
              type="primary"
              :disabled="record.IsExpire"
              @click="changeBranchRelId(record)"
              >设为默认</a-button
            >
            <span v-else style="color: red; font-weight: 700; font-size: 16px">当前授权</span>
            <a-button v-if="record.RelId != branchRelId" type="primary" danger @click="delAuthApp(record)"
              >删除</a-button
            >
          </a-space>
        </template>
      </MyTable>
      <template #footer>
        <a-button key="back" type="primary" danger @click="visible = false">关闭窗口</a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { columns } from "./tableInfo";
import handler from "./handler";
import MyTable from "@/views/base/components/table";
import { Service_GetBranchRelId, Service_SetDefaultAppToLocal } from "@/service/branch_relId_service";
import { SmileOutlined } from "@ant-design/icons-vue";
import { Modal } from "ant-design-vue";
import { createVNode } from "vue";
export default {
  props: {
    record: Object,
  },
  data() {
    return {
      visible: false,
      tableInfo: {
        page: 1,
        pageSize: 50,
        showTotal: (total) => `共 ${total} 个账号`,
        pageSizeOptions: ["20", "50", "100"],
        list: [],
        total: 0,
        tableScroll: { x: "1000px", y: "calc(100vh - 285px)" },
        loading: false,
        columns,
        rowSelection: null,
        renderSlot: ["appName", "statusStr", "appExpiresIn", "operate"],
        rowKey: "ShopId",
      },
      branchRelId: "",
    };
  },
  components: {
    MyTable,
  },
  computed: {
    getTitle() {
      return `【${this.record?.auth?.ShopName}】 - 1688授权账号管理`;
    },
  },
  methods: {
    async addAuthApp() {
      var addMallLink = await handler.GetAddAuthAppLink(this.record.isSingle ? "" : this.record.Id);
      window.open(addMallLink);
      Modal.confirm({
        title: "温馨提示",
        icon: createVNode(SmileOutlined),
        content: "成功授权请点击确认按钮!",
        okText: "确定",
        onOk: () => {
          // 授权成功后,重置页面,获取列表
          this.tableInfo.page = 1;
          this.getAuthAppList();
        },
      });
    },
    showAppAuth() {
      this.visible = true;
      this.getAuthAppList();
    },
    async getAuthAppList() {
      this.tableInfo.loading = true;
      const { page, pageSize } = this.tableInfo;
      var { msg, success, authMallList, total } = await handler.GetAuthAppList(
        page,
        pageSize,
        this.record.isSingle ? "" : this.record.Id
      );
      this.tableInfo.list = authMallList;
      this.tableInfo.total = total;
      if (!success) this.$message.warn(msg);
      this.checkIsHasDefaultInLocal(authMallList);
      this.tableInfo.loading = false;
    },
    checkIsHasDefaultInLocal(authMallList) {
      if (!authMallList.length) return;
      // 从本地获取 RelId
      var branchRelId = Service_GetBranchRelId(this.record);
      // 如果获取不到那么,就默认将第一个设置成默认的
      if (!branchRelId) {
        this.branchRelId = authMallList[0].RelId;
        Service_SetDefaultAppToLocal(this.record, authMallList[0]);
        return;
      }
      this.branchRelId = branchRelId;
    },
    async changeBranchRelId(appInfo) {
      debugger;
      this.branchRelId = appInfo.RelId;
      Service_SetDefaultAppToLocal(this.record, appInfo);
      await this.getAuthAppList();
      this.$message.success("切换成功!");
    },
    async delAuthApp(record) {
      const { success, msg } = await handler.DeleteAliAuth(record.RelId);
      const s = `删除1688授权账号【${record.ShopName}】`;
      if (!success) return this.$message.warn(`${s}失败，原因:【${msg}】`);
      this.$message.success(`${s}成功`);
      this.getAuthAppList();
    },
    ChangePage(page, size) {
      this.tableInfo.page = page;
      this.tableInfo.pageSize = size;
      this.getAuthAppList();
    },
  },
};
</script>
